import React from 'react';
import './ad-slot-marker.scss';

export interface AdSlotMarkerProps {
    id?: string;
    name: string;
    lazy?: boolean;
    auto?: boolean;
    resizable?: boolean;
    className?: string;
}

export const AdSlotMarker: React.FC<AdSlotMarkerProps> = ({ id, name, auto, lazy, resizable, className = '' }) => (
    <div
        id={id}
        data-slot={name}
        data-autoslot={auto === void 0 || auto ? 1 : 0}
        data-resizable={lazy === void 0 || lazy ? 1 : 0}
        data-prop-lazy={resizable === void 0 || resizable ? 1 : 0}
        className={`onet-ad ${className}`}
        suppressHydrationWarning={true}
    />
);
